import { hexARgb, cargarLogo, medidaLogo } from './reciboPdf';
import { lempirasEnLetras } from './numeroALetras';

// Factura con CAI en PDF tamaño carta (Acuerdo 481-2017, arts. 10 y 11).
// Sale en dos páginas idénticas: ORIGINAL (cliente) y COPIA (emisor). No se
// ofrece en ticket: el art. 38 prohíbe emitir comprobantes en papel térmico.
// Todo sale de la factura CONGELADA en la BD, así cada reimpresión es igual.

const L = (n) => `L ${Number(n || 0).toLocaleString('es-HN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fecha = (iso) => new Date(iso).toLocaleDateString('es-HN', { day: '2-digit', month: '2-digit', year: 'numeric' });
const hora = (iso) => new Date(iso).toLocaleTimeString('es-HN', { hour: 'numeric', minute: '2-digit' });
const fechaDia = (ymd) => { const [a, m, d] = String(ymd).split('-'); return `${d}/${m}/${a}`; };
const cant = (n) => Number(n).toLocaleString('es-HN', { maximumFractionDigits: 3 });

function pagina(doc, f, logo, destino) {
  const e = f.emisor || {};
  const [r, g, b] = hexARgb(e.color_principal);
  const W = 215.9, M = 14;
  let y = M;

  // Emisor (art. 10 num. 1).
  let tx = M;
  if (logo) {
    const [lw, lh] = medidaLogo(logo, 22);
    try { doc.addImage(logo.data, 'PNG', M, y, lw, lh, undefined, 'FAST'); tx = M + lw + 5; } catch { tx = M; }
  }
  const bx = W - M - 66;
  const ancho = bx - tx - 5;
  doc.setTextColor(20, 20, 20); doc.setFont('helvetica', 'bold'); doc.setFontSize(15);
  doc.text(doc.splitTextToSize(String(e.nombre || ''), ancho)[0], tx, y + 6);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor(70, 70, 70);
  let yy = y + 11.5;
  const lineas = [
    e.razon_social && e.razon_social.trim().toLowerCase() !== String(e.nombre || '').trim().toLowerCase() ? e.razon_social : null,
    `RTN: ${e.rtn}`,
    e.direccion,
    [e.telefono ? `Tel: ${e.telefono}` : null, e.correo].filter(Boolean).join('  ·  ') || null,
  ].filter(Boolean);
  lineas.forEach((l) => doc.splitTextToSize(l, ancho).forEach((t) => { doc.text(t, tx, yy); yy += 4.2; }));

  // Recuadro: denominación, número, fecha (art. 10 num. 2 y 7).
  doc.setFillColor(r, g, b); doc.roundedRect(bx, y, 66, 27, 2, 2, 'F');
  doc.setTextColor(255, 255, 255); doc.setFont('helvetica', 'bold');
  doc.setFontSize(15); doc.text('FACTURA', bx + 33, y + 8, { align: 'center' });
  doc.setFontSize(10.5); doc.text(`No. ${f.numero}`, bx + 33, y + 15, { align: 'center' });
  doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5);
  doc.text(`Fecha de emisión: ${fecha(f.fecha_emision)}  ${hora(f.fecha_emision)}`, bx + 33, y + 22, { align: 'center' });

  y = Math.max(yy, y + 27) + 4;

  // CAI, rango y fecha límite (art. 10 num. 3-5).
  doc.setDrawColor(210, 210, 210); doc.setFillColor(250, 250, 250);
  doc.roundedRect(M, y, W - 2 * M, 14, 1.5, 1.5, 'FD');
  doc.setTextColor(30, 30, 30); doc.setFontSize(8.5);
  doc.setFont('helvetica', 'bold'); doc.text('CAI:', M + 3, y + 5);
  doc.setFont('helvetica', 'normal'); doc.text(f.cai, M + 12, y + 5);
  doc.setFont('helvetica', 'bold'); doc.text('Fecha límite de emisión:', W - M - 58, y + 5);
  doc.setFont('helvetica', 'normal'); doc.text(fechaDia(f.fecha_limite), W - M - 3, y + 5, { align: 'right' });
  doc.setFont('helvetica', 'bold'); doc.text('Rango autorizado:', M + 3, y + 10.5);
  doc.setFont('helvetica', 'normal'); doc.text(f.rango_texto, M + 31, y + 10.5);
  y += 19;

  // Cliente (art. 11) y adquirente exonerado (art. 10 num. 8).
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold'); doc.text('Cliente:', M, y);
  doc.setFont('helvetica', 'normal'); doc.text(doc.splitTextToSize(f.cliente_nombre, 105)[0], M + 15, y);
  doc.setFont('helvetica', 'bold'); doc.text(f.cliente_rtn && f.cliente_rtn.length === 13 ? 'Identidad:' : 'RTN:', W - M - 60, y);
  doc.setFont('helvetica', 'normal'); doc.text(f.cliente_rtn || '—', W - M - 3, y, { align: 'right' });
  y += 5;
  const exo = [
    f.exo_orden_compra ? `No. Orden de Compra Exenta: ${f.exo_orden_compra}` : null,
    f.exo_constancia ? `No. Constancia de Registro de Exonerados: ${f.exo_constancia}` : null,
    f.exo_registro_sag ? `No. Registro SAG: ${f.exo_registro_sag}` : null,
  ].filter(Boolean);
  exo.forEach((t) => { doc.text(t, M, y); y += 4.5; });
  y += 2;

  // Detalle (valores sin ISV).
  const col = { cant: M + 2, desc: M + 20, precio: W - M - 58, desc2: W - M - 30, total: W - M - 2 };
  const encabezado = () => {
    doc.setFillColor(r, g, b); doc.rect(M, y - 4.5, W - 2 * M, 7, 'F');
    doc.setTextColor(255, 255, 255); doc.setFont('helvetica', 'bold'); doc.setFontSize(8.5);
    doc.text('CANT.', col.cant, y); doc.text('DESCRIPCIÓN', col.desc, y);
    doc.text('PRECIO UNIT.', col.precio, y, { align: 'right' });
    doc.text('DESCUENTO', col.desc2, y, { align: 'right' });
    doc.text('TOTAL', col.total, y, { align: 'right' });
    y += 7;
  };
  encabezado();
  doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor(30, 30, 30);
  (f.detalle || []).forEach((it) => {
    const marca = it.impuesto === 'exento' ? ' (E)' : (it.impuesto === 'exonerado' ? ' (EXO)' : (it.impuesto === 'g18' ? ' (18%)' : ''));
    const lns = doc.splitTextToSize(`${it.descripcion}${marca}`, col.precio - col.desc - 26);
    if (y + lns.length * 4.2 > 205) { doc.addPage(); y = M + 6; encabezado(); doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor(30, 30, 30); }
    doc.text(cant(it.cantidad), col.cant, y);
    doc.text(lns, col.desc, y);
    doc.text(L(it.precio_unitario), col.precio, y, { align: 'right' });
    doc.text(Number(it.descuento) > 0 ? L(it.descuento) : '—', col.desc2, y, { align: 'right' });
    doc.text(L(it.total), col.total, y, { align: 'right' });
    y += lns.length * 4.2 + 3;
    doc.setDrawColor(235, 235, 235); doc.line(M, y - 3.6, W - M, y - 3.6);
  });

  // Totales y desglose (art. 11: exentos, exonerados, gravados e impuestos).
  if (y > 200) { doc.addPage(); y = M + 6; }
  y += 2;
  const yTot = y;
  const fila = (etq, val, fuerte) => {
    doc.setFont('helvetica', fuerte ? 'bold' : 'normal'); doc.setFontSize(fuerte ? 11 : 8.8);
    if (fuerte) doc.setTextColor(r, g, b); else doc.setTextColor(50, 50, 50);
    doc.text(etq, W - M - 82, y); doc.text(val, W - M - 2, y, { align: 'right' });
    y += fuerte ? 7 : 4.6;
  };
  fila('Subtotal', L(f.subtotal));
  fila('Descuentos y rebajas otorgados', L(f.descuentos));
  fila('Importe exonerado', L(f.importe_exonerado));
  fila('Importe exento', L(f.importe_exento));
  fila('Importe gravado 15%', L(f.importe_gravado_15));
  fila('Importe gravado 18%', L(f.importe_gravado_18));
  fila('ISV 15%', L(f.isv_15));
  fila('ISV 18%', L(f.isv_18));
  doc.setDrawColor(190, 190, 190); doc.line(W - M - 82, y - 2.5, W - M, y - 2.5); y += 2.5;
  fila('TOTAL A PAGAR', L(f.total), true);

  // Total en letras y forma de pago (a la izquierda de los totales).
  doc.setTextColor(40, 40, 40); doc.setFontSize(8.5);
  doc.setFont('helvetica', 'bold'); doc.text('Valor en letras:', M, yTot);
  doc.setFont('helvetica', 'normal');
  let yl = yTot + 4.5;
  doc.splitTextToSize(lempirasEnLetras(f.total), 95).forEach((t) => { doc.text(t, M, yl); yl += 4.2; });
  if (f.forma_pago) { yl += 2; doc.setFont('helvetica', 'bold'); doc.text('Forma de pago:', M, yl); doc.setFont('helvetica', 'normal'); doc.text(f.forma_pago, M + 25, yl); yl += 4.5; }
  if ((f.detalle || []).some((it) => it.impuesto === 'exento')) { yl += 1; doc.setFontSize(7.5); doc.setTextColor(110, 110, 110); doc.text('(E) = producto exento de ISV', M, yl); }

  y = Math.max(y, yl) + 6;
  if (e.pie) {
    doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor(80, 80, 80);
    doc.splitTextToSize(e.pie, W - 2 * M).forEach((t) => { doc.text(t, W / 2, y, { align: 'center' }); y += 4.2; });
  }

  // Destino del ejemplar (art. 10 num. 6) y pie.
  const H = 279.4;
  doc.setDrawColor(r, g, b); doc.setLineWidth(0.4); doc.line(M, H - 22, W - M, H - 22); doc.setLineWidth(0.2);
  doc.setFont('helvetica', 'bold'); doc.setFontSize(10); doc.setTextColor(r, g, b);
  doc.text(destino, W / 2, H - 16, { align: 'center' });
  doc.setFont('helvetica', 'normal'); doc.setFontSize(7.5); doc.setTextColor(130, 130, 130);
  doc.text('Original: Cliente   ·   Copia: Obligado tributario emisor', W / 2, H - 11.5, { align: 'center' });
  doc.text('Emitida por sistema computarizado (autoimpresor) · Kontrol by Automatika.IA', W / 2, H - 7.5, { align: 'center' });

  // Factura anulada (art. 41): leyenda "ANULADA".
  if (f.estado === 'anulada') {
    doc.setTextColor(220, 38, 38); doc.setFont('helvetica', 'bold'); doc.setFontSize(80);
    try { doc.setGState(new doc.GState({ opacity: 0.25 })); } catch { /* sin transparencia */ }
    doc.text('ANULADA', W / 2, H / 2 + 10, { align: 'center', angle: 30 });
    try { doc.setGState(new doc.GState({ opacity: 1 })); } catch { /* nada */ }
    if (f.motivo_anulacion) {
      doc.setFontSize(9); doc.text(`Anulada: ${f.motivo_anulacion}`, W / 2, H - 26, { align: 'center' });
    }
  }
}

// Arma el PDF (original + copia). Devuelve { doc, nombreArchivo }.
export async function armarFacturaPdf(factura) {
  const { jsPDF } = await import('jspdf');
  const logo = await cargarLogo(factura.emisor?.logo_url);
  const doc = new jsPDF({ unit: 'mm', format: 'letter' });
  pagina(doc, factura, logo, 'ORIGINAL: CLIENTE');
  doc.addPage();
  pagina(doc, factura, logo, 'COPIA: OBLIGADO TRIBUTARIO EMISOR');
  return { doc, nombreArchivo: `Factura-${factura.numero}${factura.estado === 'anulada' ? '-ANULADA' : ''}.pdf` };
}

export { pagina as _paginaFactura };
